import merge from 'lodash/merge';

const mergeWithDefaultConfig = config => {
  const defaultConfig = {
    cUrl: { value: window.location.href },
    expirationPeriod: 30,
    toast: {
      inquiryTxt:
        'キャンペーンをより分かりやすくするためにアンケートにご協力ください (選択式1問)',
      yesBtnTxt: '協力する',
      noBtnTxt: '今は協力しない',
      thanksTxt0: 'ご協力ありがとうございました',
      thanksTxt1:
        'いただいた情報は、サービス改善のために使用させていただきます。',
      availableOnDesktop: true,
      availableOnMobile: true,
    },
    inquiry: {
      question: 'このページでわかりにくいところを教えてください (複数回答可)',
      options: [],
      freeInput: {
        available: false,
        title: '自由回答',
      },
      sendBtnTxt: '送信する',
    },
  };
  return merge({}, defaultConfig, config);
};

export default mergeWithDefaultConfig;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/mergeWithDefaultConfig.js